import type * as React from 'react';

export const formatMoney = (
  value: string | number,
  withUnit = false
): string => {
  const valueNumber =
    typeof value === 'string' ? parseFloat(value.replace(',', '.')) : value;
  const money = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
  }).format(valueNumber);

  return withUnit ? money : money.replace('R$', '');
};

export function mergeRefs<T = any>(
  refs: Array<React.MutableRefObject<T> | React.LegacyRef<T> | undefined | null>
): React.RefCallback<T> {
  return (value) => {
    refs.forEach((ref) => {
      if (typeof ref === 'function') {
        ref(value);
      } else if (ref != null) {
        (ref as React.MutableRefObject<T | null>).current = value;
      }
    });
  };
}
